import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { useDispatch, useSelector } from "react-redux"
import { Spacer } from "../../atoms/Atoms"
import { updateUserInfo } from "../../../../actions/userActions"
import { getMemberPlanSourceSelectValue } from "../../../../reducers/userInfo"
import {
  BenefitEnrollmentFlowModalBackButton,
  BenefitEnrollmentModalContinueButton,
  BenefitEnrollmentModalFormSelect
} from "./BenefitEnrollmentFlowModal"
import { FormProvider, useForm } from "react-hook-form"
import { Steps } from "./Workflow/Steps"
import useSubmitWithErrorCatch from "./hooks/useSubmitWithErrorCatch"
import { useProgressTracker } from "../ProgressTracker"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FieldName = "memberPlanSourceSelectValue"
const ViewName = Steps.MEMBER_PLAN_SOURCE

const MemberPlanSourceView: FC = () => {
  const dispatch = useDispatch()
  const { setNextStep } = useStateMachine()
  const memberPlanSourceSelectValue = useSelector(getMemberPlanSourceSelectValue)
  const { onSubmit } = useSubmitWithErrorCatch(async (args) => {
    const memberPlanSourceSelectValue = args[FieldName].id
    await dispatch(updateUserInfo({ memberPlanSourceSelectValue }))
    setNextStep(ViewName, memberPlanSourceSelectValue)
  })

  return (
    <BenefitEnrollmentModalViewContainer
      viewName={ViewName}
      fieldName={FieldName}
      fieldValue={memberPlanSourceSelectValue}
      onSubmit={onSubmit}
    >
      <BenefitEnrollmentModelViewContents {...{ fieldValue: memberPlanSourceSelectValue }} />
    </BenefitEnrollmentModalViewContainer>
  )
}

const BenefitEnrollmentModelViewContents = ({ fieldValue }: any) => (
  <>
    <H2 variant="dark">{l`Where do you get your health insurance?`}</H2>
    <Spacer height={2} />
    <BenefitEnrollmentModalFormSelect
      name={FieldName}
      defaultValue={fieldValue}
      options={[
        { label: l(`From my employer`), id: "EMPLOYER" },
        { label: l(`From my partner's employer`), id: "PARTNER" },
        { label: l(`From my parent's employer`), id: "PARENT" },
        { label: l(`I buy it, or get it through a federal program`), id: "OTHER" },
        { label: l(`I'm not insured`), id: "NOT_INSURED" }
      ]}
    />
    <Spacer height={16} />
  </>
)

const BenefitEnrollmentModalViewContainer = ({ viewName, fieldName, fieldValue, onSubmit, children }) => {
  const { setProgress } = useProgressTracker()
  const formMethods = useForm()
  useStateMachine(viewName, fieldValue)

  setProgress(1, "YOUR INSURANCE COVERAGE")

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <BenefitEnrollmentFlowModalBackButton />
      <Spacer height={3} />
      {children}
      <BenefitEnrollmentModalContinueButton onClick={handleSubmit(onSubmit)} />
    </FormProvider>
  )
}

export { MemberPlanSourceView }
